<!--
 * @FileDescription: 学校整体数据统计栏
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 12:17:51
 -->
<template>
  <div class="stat-container">
    <StatNumber v-for="stat in statNumberInfo" :key="stat.statName" :statName=stat.statName :statNumber=stat.statNumber
      :logoType=stat.logoType />
    <div class="nnu-logo"></div>
  </div>
</template>

<script>
import StatNumber from './StatNumber.vue';
// import activeJson from "@/components/activeChartData.json"
export default {
  name: 'StatHeader',
  components: {
    StatNumber,
  }
}
</script>

<script setup>
import axios from 'axios';
import { ref, onMounted } from 'vue';

let activeJson = ref({})

let statNumberInfo = ref([])

onMounted(() => {
  axios.get('/activeChartData.json')
    .then(response => {
      activeJson.value = response.data;
      statNumberInfo.value = [
        { statName: "本科生人数", statNumber: activeJson.value.schoolInformation.underGra, logoType: "student-logo" },
        { statName: "研究生人数", statNumber: activeJson.value.schoolInformation.graStudent, logoType: "graduate-logo" },
        { statName: "国家一流专业建设点", statNumber: activeJson.value.schoolInformation.constructPoint, logoType: "school-logo" },
        { statName: "江苏高校优势学科", statNumber: activeJson.value.schoolInformation.advDiscipline, logoType: "subject-logo" },
        { statName: "省高校重点实验室", statNumber: activeJson.value.schoolInformation.keyLaboratory, logoType: "lab-logo" },
        { statName: "校际交流高校", statNumber: activeJson.value.schoolInformation.exchangeSchool, logoType: "communication-logo" },
      ]
    })
    .catch(error => {
      console.log(error);
    });
})


</script>

<style scoped lang="scss">
div.stat-container {
  height: 10vh;
  width: 98vw;
  padding-left: 2vw;
  background: transparent;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  column-gap: 2.8vw;
  z-index: 3;

  div.nnu-logo {
    position: absolute;
    // background-color: red;
    margin-top: 2vh;
    width: 10vw;
    height: 5vh;
    right: 1vw;
    background-image: url("http://223.2.9.189:8080/image/ft-logo.png");
    background-size: 10vw 5vh;
    background-repeat: no-repeat;
    z-index: 1;
  }
}
</style>
